import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Building2, ShieldCheck, Wrench } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PmMyProperties = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scope, setScope] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/pm/me/properties`, { withCredentials: true });
        setItems(data.items || []);
        setScope(data.scope || '');
      } catch { /* ignore */ }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="pm-my-properties">
      <div>
        <h1 className="text-2xl font-semibold text-white flex items-center gap-2"><Wrench className="w-6 h-6 text-[#D4AF37]" /> My Properties</h1>
        <p className="text-[#A3A3A3] text-sm mt-1">Properties you have access to. {scope === 'group-based' ? 'Access is granted via access groups.' : 'You have company-wide access.'}</p>
      </div>

      {loading ? <div className="p-6 text-[#A3A3A3]">Loading…</div> : items.length === 0 ? (
        <div className="bg-[#141414] border border-[#262626] rounded-md p-12 text-center text-[#A3A3A3]" data-testid="no-properties">
          <p>You don't have access to any properties yet. Ask your PM-Admin to add you to an access group.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {items.map((p) => (
            <Link key={p.id} to={`/pm/properties/${p.id}`} data-testid={`my-prop-${p.id}`} className="bg-[#141414] border border-[#262626] rounded-md p-4 hover:border-[#D4AF37] transition">
              <div className="flex items-start justify-between gap-2">
                <h3 className="text-white font-medium flex items-center gap-2"><Building2 className="w-4 h-4 text-[#D4AF37]" /> {p.property_name}</h3>
                <Badge className="bg-[#262626] text-[#A3A3A3] border-[#404040]">{p.unit_count} units</Badge>
              </div>
              <p className="text-[#A3A3A3] text-xs mt-2">{p.address}{p.city ? `, ${p.city}` : ''} {p.state} {p.zip}</p>
              <div className="mt-3 space-y-1 text-xs">
                {p.gate_code && <p className="text-white"><span className="text-[#A3A3A3]">Gate:</span> <span className="font-mono text-[#D4AF37]">{p.gate_code}</span></p>}
                {p.lockbox_code && <p className="text-white"><span className="text-[#A3A3A3]">Lockbox:</span> <span className="font-mono text-[#D4AF37]">{p.lockbox_code}</span></p>}
                {p.access_instructions && <p className="text-[#A3A3A3] italic flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Has access notes</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default PmMyProperties;
